import { Injectable } from '@angular/core'; 
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HTTP_INTERCEPTORS } from '@angular/common/http'; 
import { Observable } from 'rxjs'; import { TokenStorageServiceService } from './token-storage-service.service';
 const TOKEN_HEADER_KEY = 'Authorization';
  @Injectable() 
export class InterceptorInterceptor implements HttpInterceptor { 
    constructor(private token:TokenStorageServiceService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> { 
  let authReq = req; const token = this.token.getToken(); 
  if (token != null) {
     authReq = req.clone({ headers: req.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + token) }); 
    } 
    
    return next.handle(authReq); } }
 export const authInterceptorProviders = [
    {
       provide: HTTP_INTERCEPTORS, useClass: InterceptorInterceptor, multi: true 
      } ];